import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import LoginModal from "@/components/LoginModal";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginOpen, setLoginOpen] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
    window.location.href = "/";
  };

  // Opens the login chooser (Google + phone OTP). Keeps the same API as before
  // so existing `login()` call-sites work unchanged.
  const login = () => setLoginOpen(true);

  const handleOtpLoggedIn = (payload) => {
    // OTP endpoint sets the session_token cookie (same as Google login); just refresh user.
    if (payload?.user) setUser(payload.user);
    setLoginOpen(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout, login }}>
      {children}
      <LoginModal
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onLoggedIn={handleOtpLoggedIn}
      />
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
